import React, { ReactElement, useEffect, useState } from 'react';
import { Fournisseur, Produit } from '../../../../../common/src/entities';
import ChampFormulaire from '../../Common/ChampFormulaire';
import { useFormikContext } from 'formik';
import { useEntites } from '../../../Utils/api';
import { EtatEntite } from '../../Common/EtatEntite';
import CheckboxFormulaireEtatEntite from '../../Common/CheckboxFormulaireEtatEntite';
import { LABEL_COL } from '../constantes';
import { MyPaper } from '../Utils/MyPaper';

interface IChampsState<T> {
    value: T;
}

interface IChampsProduitState {
    fournisseur: IChampsState<Fournisseur | undefined>;
}

export default function ChampsProduitCreer(): ReactElement {
    const { data } = useEntites(Fournisseur);
    const { values, setFieldValue } = useFormikContext<Produit>();

    const fournisseur = data?.find((f) => f.id == values.fk_id_fournisseur);
    const [state, setState] = useState<IChampsProduitState>({
        fournisseur: {
            value: fournisseur as Fournisseur,
        } as IChampsState<Fournisseur | undefined>,
    } as IChampsProduitState);

    useEffect(() => {
        setFieldValue('created_at', new Date().toUTCString());
        setFieldValue('date_derniere_modification', new Date().toUTCString());
        setFieldValue('actif', !!values.actif);
    }, [values]);

    function EtatProduit(): JSX.Element {
        return (
            <EtatEntite>
                <CheckboxFormulaireEtatEntite id="actif" titre="Actif" />
            </EtatEntite>
        );
    }

    return (
        <div className="pb-5">
            {EtatProduit()}
            <MyPaper>
                <ChampFormulaire labelCol={LABEL_COL} id="name" titre="Nom" estPetit />
            </MyPaper>
        </div>
    );
}
